import { AiOutlineClose } from "react-icons/ai";

const CloseButton = ({ closeToast }) => {
  return (
    <div
      className="noty-close-icon"
      onClick={closeToast}
      style={{
        backgroundColor: "#FFFFFF",
        position: "absolute",
        border: ".5px solid #70707040",
        top: "-10px",
        width: "20px",
        height: "20px",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        left: "10px",
      }}>
      <AiOutlineClose size={10} color="#707070" />
    </div>
  );
};

export default CloseButton;
